export default {
  title: 'Menuens redigeringshistorik',
  subtitle: 'Se, hvem der har ændret priser, tilgængelighed og synlighed for {{company}} – og hvornår.',
  filters: {
    type: {
      label: 'Type',
    },
    item: {
      placeholder: 'Alle varer',
    },
    event: {
      label: 'Hændelse',
    },
  },
  columns: {
    when: 'Hvornår',
    who: 'Ændret af',
    type: 'Type',
    item: 'Vare',
    event: 'Hændelse',
    changes: 'Ændringer',
  },
  types: {
    product: 'Produkt',
    modifier: 'Tilvalg',
  },
  events: {
    created: 'Oprettet',
    updated: 'Opdateret',
    deleted: 'Slettet',
  },
  fields: {
    name: 'Navn',
    description: 'Beskrivelse',
    price: 'Pris',
    is_available: 'Tilgængelighed',
    is_visible: 'Synlighed',
    is_available_for_pickup: 'Tilgængelighed til afhentning',
    is_available_for_delivery: 'Tilgængelighed til levering',
  },
  booleans: {
    on: 'Tilgængelig',
    off: 'Ikke tilgængelig',
  },
  pagination: {
    previous: 'Forrige',
    next: 'Næste',
  },
  causers: {
    orders_terminal: 'Ordreterminal',
  },
  system: 'System',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Menuens redigeringshistorik kunne ikke indlæses',
  },
};
